import type { IconSvgObject } from './types';

const CastIcon: IconSvgObject = [
  ["path", { d: "M8 21C8 18.2386 5.76142 16 3 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 21C12 16.0294 7.97056 12 3 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.25 20.625V20.75M3.5 20.75C3.5 20.8881 3.38807 21 3.25 21C3.11193 21 3 20.8881 3 20.75C3 20.6119 3.11193 20.5 3.25 20.5C3.38807 20.5 3.5 20.6119 3.5 20.75Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 8V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CastIcon;
